<template>
  <b-container fluid>
    <div>
      <div v-if="isAdmin">
        <b-modal header-bg-variant="primary" size="lg" ref="confirmationModal" id="confirmationModal" centered :title="confirmationModalData.confirmationModalTitle"
          @ok="handleSaveModal"
          @cancel="confirmationModalData.confirmationModalCancelHandler"
          :hide-footer="currentStatus == 'APPROVED' ? !showModalFooter: false"
          cancel-title="Cancelar">
          <moon-loader class="mb-2" :loading="loading" color="#000" size="30px"></moon-loader>
          <span v-show="!loading && currentStatus != 'APPROVED'">{{confirmationModalData.confirmationModalText}}</span>
          <FormActiveSku :products="1" @showbtns="isvalidForm" v-if="currentStatus == 'APPROVED'"/>
        </b-modal>
      </div>
      <div v-else>
        <b-modal header-bg-variant="primary" size="lg" ref="confirmationModal" id="confirmationModal" centered :title="confirmationModalData.confirmationModalTitle"
          @ok="confirmationModalData.confirmationModalOkHandler"
          @cancel="confirmationModalData.confirmationModalCancelHandler"
          cancel-title="Cancelar">
          <moon-loader class="mb-2" :loading="loading" color="#000" size="30px"></moon-loader>
          <span v-show="!loading">{{confirmationModalData.confirmationModalText}}</span>
        </b-modal>
      </div>

      <b-modal @hidden="handleHide" :ok-disabled="createButtonDisabled || isAdmin" header-bg-variant="primary" centered size="lg" centered ref="skuModal" id="skuModal" :title="title" o-close-on-backdrop="true" cancel-title="Cerrar" @ok="handleOk" @cancel="handleHide" :ok-title="okTitle" >
        <moon-loader class="mb-2" :loading="loading" color="#000" size="30px"></moon-loader>
        <b-row>
          <b-col>
            <p v-show="product.skus && product.skus.length === 0" class="alert alert-warning"><i class="fa fa-exclamation-triangle"></i> Es obligatorio crear un SKU para que el producto sea vendible en el marketplace</p>
          </b-col>
        </b-row>
        <div v-html="errorText" v-show="errorText !== ''" class="alert alert-danger" role="alert">
          {{errorText}}
        </div>
        <div class="w-100 text-right">
          <router-link :to="{ path: '/incidents/list', query: { sku: sku.id }}">{{$t('Crear incidencia')}}</router-link>
        </div>
        <div v-show="successText !== ''" class="alert alert-success" role="alert">
          {{successText}}
        </div>
        <b-row class="mt-4">
          <b-col v-if="isAdmin">
            <b-form-group
              id="estadoSelectGroup"
              :label-cols="2"
              breakpoint="md"
              label="Estado"
              label-for="estadoSelectInput">
              <b-form-select id="estadoSelectInput"
                :options="estados"
                @change="changeStatusModal"
                required
                :disabled="sku.status !== 'PENDING_APPROVAL'"
                v-model="sku.status">
              </b-form-select>
            </b-form-group>
          </b-col>
          <b-col v-if="!isAdmin">
            <button :disabled="!product.id" type="button" class="btn btn-primary float-right"  @click="deleteSku">
              <i class="far fa-trash-alt"></i> Eliminar Variante
            </button>
          </b-col>
        </b-row>
        <b-row class="border my-3 pt-3">
          <b-col>
            <b-form-group id="upcInput"
                :label-cols="2"
                breakpoint="md"
                :invalid-feedback="!isValidUPC(sku.upc, true, false)? 'No es un valor válido' : ''"
                :state="isValidUPC(sku.upc, true, false)"
                label="UPC">
                <b-form-input
                  v-model="sku.upc"
                  :disabled="Boolean(sku.id)"
                ></b-form-input>
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group id="skuInput"
                :label-cols="2"
                breakpoint="md"
                description="Generado automáticamente por Vtex una vez aprobado"
                label="SKU"
                label-for="skuFormatterHelp">
              <b-form-input type="number" id="skuFormatterHelp" v-model="sku.id" disabled></b-form-input>
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group
              id="nombreInput"
              :label-cols="2"
              breakpoint="md"
              label="Nombre"
              description="Máximo 100 caracteres"
              :invalid-feedback="!isValidText(sku.skuName, true) && !editionDisabled ? 'El nombre no es válido' : ''"
              :state="isValidText(sku.skuName, true)"
              label-for="nombreFormatterHelp">
              <b-form-input
                id="nombreFormatterHelp"
                v-model="sku.skuName"
                :disabled="editionDisabled || sku.status === 'APPROVED'"
                maxlength="100">
              </b-form-input>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row class="my-3 pt-3">
          <b-col cols="12" sm="6" md="4">
            <b-form-group id="inventoryInput"
                :label-cols="2"
                breakpoint="md"
                :invalid-feedback="!isValidInt32Integer(sku.inventory.totalQuantity, false, false)? 'No es un inventario valido' : ''"
                :state="isValidInt32Integer(sku.inventory.totalQuantity, false, false)"
                description="Ingrese un valor de inventario valido"
                label="Inventario">
                <b-form-input
                  v-model="sku.inventory.totalQuantity"
                  :disabled="editionDisabled"
                ></b-form-input>
            </b-form-group>
          </b-col>
          <b-col cols="12" sm="6" md="4">
            <b-form-group id="inventorySecurityStock"
                :label-cols="2"
                breakpoint="md"
                :invalid-feedback="!isValidInt32Integer(sku.inventory.stockSecurity, true, false)? 'No es un número válido' : ''"
                :state="isValidInt32Integer(sku.inventory.stockSecurity, true, false)"
                description="Ingrese un valor de stock válido"
                label="Stock de seguridad">
                <b-form-input
                  name="security-stock"
                  autocomplete="off"
                  v-model="sku.inventory.stockSecurity"
                ></b-form-input>
            </b-form-group>
          </b-col>
          <b-col cols="12" sm="6" md="4">
            <b-form-group id="refId"
                :label-cols="4"
                breakpoint="md"
                :description="Boolean(verifyInProgress) ? 'Verificando el refId, espere...' : 'Ingrese el código de referencia'"
                :invalid-feedback="!editionDisabled ? refIdFeedback : ''"
                :state="!Boolean(refIdFeedback)"
                label="Código de referencia"
                label-for="refId">
              <b-form-input
                  :disabled="editionDisabled || sku.status === 'APPROVED'"
                  type="text"
                  id="refId"
                  v-model="sku.refId"></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <price-and-dimencion :pricesDisabled="editionDisabled" :sizesDisabled="editionDisabled || sku.status === 'APPROVED'" :priceData="sku.price" :dimension="sku.dimension"></price-and-dimencion>
        </b-row>
        <b-row>
          <image-loader :disabled="editionDisabled" @imageJustLoaded="imageJustLoaded" @imageDeleted="_addImagesAndFinishCreation" :skuId="sku.id" :productImages="sku.images" ref="imageLoader"></image-loader>
        </b-row>
        <b-row>
          <product-attributes :disabled="editionDisabled || sku.status === 'APPROVED'" :mergedInfo="specificationsComputedMap"></product-attributes>
        </b-row>
        <b-row>
          <sku-history :history="history"></sku-history>
        </b-row>
      </b-modal>
    </div>
  </b-container>
</template>

<script>
import MoonLoader from 'vue-spinner/src/MoonLoader.vue'
import { ValidationsMixim } from '@/mixims/ValidationsMixim.js'
import PriceAndDimencion from './PriceAndDimencion'
import ProductAttributes from './ProductAttributes'
import SkuHistory from './SkuHistory'
import { ProductServiceMixim, PRODUCT_STATES_EDITION } from '@/mixims/ProductServiceMixim.js'
import ImageLoader from '@/components/common/ImageLoader'
import FormActiveSku from '@/components/common/FormActiveSku'

export default {
  name: 'sku-modal',
  components: {
    MoonLoader,
    PriceAndDimencion,
    ProductAttributes,
    SkuHistory,
    ImageLoader,
    FormActiveSku
  },
  mixins: [ValidationsMixim, ProductServiceMixim],
  data () {
    return {
      activateProductData: [],
      showModalFooter: false,
      isAdmin: this.$store.getters.isAdmin,
      title: '',
      loading: false,
      specifications: [],
      successText: '',
      mute: true,
      errorText: '',
      currentStatus: '',
      estados: PRODUCT_STATES_EDITION,
      confirmationModalData: {
        confirmationModalOkHandler: '',
        confirmationModalCancelHandler: '',
        confirmationModalText: '',
        confirmationModalTitle: ''
      },
      sku: {
        price: {},
        dimension: {},
        inventory: {},
        images: [],
        skuSpecifications: [],
        refId: ''
      },
      product: {},
      history: [],
      refIdFeedback: '',
      refIdValidation: true,
      timeout: null,
      prev: '',
      oldRefId: '',
      verifyInProgress: false
    }
  },
  watch: {
    sku: {
      handler (newVal) {
        if (newVal.refId !== this.prev) {
          this.prev = this.sku.refId
          this.handleInvalidFeedback()
        }
      },
      deep: true
    }
  },
  computed: {
    okTitle: function () {
      return this.sku.id ? 'Guardar' : 'Crear Variante'
    },
    editionDisabled: function () {
      if (!this.sku.upc || !this.isValidUPC(this.sku.upc, true, false) || this.isAdmin) {
        return true
      }
      return false
    },
    createButtonDisabled: function () {
      if (!this.isValidText(this.sku.skuName, true)) {
        return true
      }

      if (!this.isValidInt32Integer(this.sku.refId, true, false) || this.refIdFeedback) {
        return true
      }

      if (!this.isValidFloat(this.sku.dimension.height, true, true) || !this.isValidFloat(this.sku.dimension.length, true, true) || !this.isValidFloat(this.sku.dimension.weight, true, true) || !this.isValidFloat(this.sku.dimension.width, true, true)) {
        return true
      }

      if (!this.isValidFloat(this.sku.price.listPrice, true, true)) {
        return true
      }

      if (this.isValidFloat(this.sku.price.price, true) && !this.isValidFloat(this.sku.price.listPrice, true, true)) {
        return true
      }

      if (!this.isValidInt32Integer(this.sku.inventory.totalQuantity, false, true)) {
        return true
      }

      if (!this.isValidInt32Integer(this.sku.inventory.stockSecurity, true, false)) {
        return true
      }

      if (this.isValidFloat(this.sku.price.price, true) && this.isValidFloat(this.sku.price.listPrice, true, true)) {
        if (parseFloat(this.sku.price.price) > parseFloat(this.sku.price.listPrice)) {
          return true
        }
      }

      if (parseFloat(this.sku.price.price) < parseFloat(this.sku.price.listPrice)) {
        if (this.isEmptyData(this.sku.price.priceValidUntil)) return true

        let dateSelected = new Date(this.sku.price.priceValidUntil)
        let today = new Date()
        today.setHours(0, 0, 0, 0)
        if (today > dateSelected) return true
      }

      if (this._pendingProps()) {
        return true
      }
      return !this.$refs.imageLoader.hasImages()
    },
    specificationsComputedMap: function () {
      if (!this.sku.skuSpecifications) {
        this.sku.skuSpecifications = []
      }
      let attributes = this.sku.skuSpecifications
      return this.specifications.map(spec => {
        let newAttr
        let foundAttr = attributes.find(attr => attr && attr.name === spec.name)
        if (!foundAttr) {
          newAttr = {
            ...spec,
            specificationFieldValues: [{}]
          }
          this.sku.skuSpecifications.push(newAttr)
        }
        return {
          spec,
          value: foundAttr !== undefined ? foundAttr : newAttr}
      })
    }
  },
  methods: {
    isvalidForm (stateForm) {
      this.activateProductData = stateForm.data
      this.showModalFooter = stateForm.state
    },
    changeStatusModal (status) {
      this.confirmationModalData.confirmationModalTitle = `Cambio de estado de ${this.sku.skuName}`
      this.confirmationModalData.confirmationModalText = `¿Cambiar el estado a ${status === 'REJECTED' ? 'rechazado' : 'activado'}?`
      this.currentStatus = status
      this.$refs.confirmationModal.show()
      this.confirmationModalData.confirmationModalCancelHandler = () => {
        this.sku.status = 'PENDING_APPROVAL'
        this.hurryShow()
      }
    },
    handleSaveModal () {
      // this.confirmationModalData.confirmationModalOkHandler = () => {
      this.execChangeStatus()
      // }
    },
    execChangeStatus () {
      this.hurryShow()
      this.loading = true
      this.errorText = ''
      this.successText = ''
      let errorVerv = ''
      let actionFunction = ''
      let _acceptances = null
      switch (this.currentStatus) {
        case 'APPROVED':
          actionFunction = this.activateProducts
          errorVerv = 'aprobando'
          _acceptances = this.activateProductData
          break
        case 'REJECTED':
          actionFunction = this.rejectProducts
          errorVerv = 'rechazando'
          break
      }
      actionFunction([this.sku.id], true, _acceptances).then(
        () => {
          this.successText = ' El estado fue modificado con éxito'
          this.loading = false
          this.mute = false
        },
        (error) => {
          console.log(error)
          this.loading = false
          this.sku.status = 'PENDING_APPROVAL'
          this.errorText = `Error ${errorVerv} el producto ${this.sku.id}`
          if (this.currentStatus === 'APPROVED') {
            if (this.sku.images.length === 0) {
              this.errorText += '<ul>'
              this.errorText += '  <li>El producto no tiene imagenes cargadas.</li>'
              this.errorText += '</ul>'
            }
          }
        }
      )
    },
    deleteSku () {
      this.confirmationModalData.confirmationModalTitle = `Eliminar SKU`
      this.confirmationModalData.confirmationModalText = `Se procedera a eliminar la  variante ${this.sku.skuName}`
      this.confirmationModalData.confirmationModalOkHandler = () => {
        this.loading = true
        this.deleteProducts([this.sku.id], true).then(
          () => {
            this.loading = false
            this.$emit('needReload', {status: true, text: 'Se elimino la variante'})
            this.$refs.confirmationModal.hide()
          },
          (error) => {
            this.loading = false
            this.$emit('needReload', {status: false, text: error.body.message || 'Error eliminando la variante'})
            this.$refs.confirmationModal.hide()
          }
        )
      }
      this.confirmationModalData.confirmationModalCancelHandler = () => {
        this.hurryShow()
      }
      this.mute = true
      this.$refs.confirmationModal.show()
    },
    _addImagesAndFinishCreation (successText, isCreation) {
      let _this = this
      /* Upload the images */
      let temp = this.sku.dimension.height
      this.sku.dimension.height = 0
      this.sku.dimension.height = temp
      this.$refs.imageLoader.uploadImages(this.sku.id).then(
        (images) => {
          _this.sku.images = images
          /* Update the SKU with the just upload images */
          this.updateSku(_this.sku.id, _this.sku).then(
            (skuJustCreated) => {
              if (isCreation) {
                _this.product.skus.push(skuJustCreated.body)
              } else {
                this.mute = false
              }
              this.successText = successText || 'Imagen eliminada con éxito'
              this.loading = false
            },
            (error) => {
              console.log(error)
              if (error.status === 500) {
                this.errorText = 'Error al guardar la variante. Revise los campos ingresados.'
              } else {
                this.errorText = 'Error al guardar la variante.'
              }
              this.loading = false
            }
          )
        },
        (error) => {
          if (error.message === '413') {
            this.errorText = 'La imagen que intentaste subir supera el límite permitido por imagen.'
          } else {
            this.errorText = 'Error ejecutando el servicio para subir las imágenes'
          }
          this.loading = false
        }
      )
    },
    _pendingProps () {
      return this.specificationsComputedMap.some(
        (prop) => {
          if (prop.value.isRequired && prop.value.specificationFieldValues.length > 0) {
            return Object.keys(prop.value.specificationFieldValues).length === 0 || !prop.value.specificationFieldValues[0].value
          }
        }
      )
    },
    _createSku () {
      this.loading = true
      if (!this.$refs.imageLoader.hasImages()) {
        this.loading = false
        this.errorText = 'No hay ninguna imagen seleccionada'
        return
      }
      /* Create the SKU */
      this.createSku(this.product.id, this.sku).then(
        (res) => {
          this.sku.id = res.id
          this.sku.status = res.status
          /* We have the sku, so we can upload the images and update de sku */
          this._addImagesAndFinishCreation('La variante fue creada con exito', true)
        },
        (error) => {
          console.log(error)
          this.errorText = 'Error ejecutando el servicio de creacion de variantes'
          this.loading = false
        }
      )
    },
    _updateSku () {
      this.loading = true
      if (!this.$refs.imageLoader.hasImages()) {
        this.loading = false
        this.errorText = 'No hay ninguna imagen seleccionada'
        return
      }
      /* We have the sku, so we can upload the images and update de sku */
      this._addImagesAndFinishCreation('La variante fue actualizado con exito')
    },
    handleOk (evt) {
      evt.preventDefault()
      this.errorText = ''
      this.successText = ''
      if (!this.sku.id) {
        this.confirmationModalData.confirmationModalTitle = `Procesar alta de Variante: ${this.sku.skuName}`
      } else {
        this.confirmationModalData.confirmationModalTitle = `Procesar modificacion de Variante: ${this.sku.skuName}`
      }
      this.confirmationModalData.confirmationModalText = '¿Desea continuar?'
      this.confirmationModalData.confirmationModalOkHandler = () => {
        this.hurryShow()
        if (!this.sku.id) {
          this._createSku()
        } else {
          this._updateSku()
        }
      }
      this.confirmationModalData.confirmationModalCancelHandler = () => {
        this.hurryShow()
      }
      this.$refs.confirmationModal.show()
    },
    handleHide () {
      if (!this.mute) {
        this.$emit('needReload')
      }
      this.$refs.skuModal.hide()
    },
    imageJustLoaded () {
      this.errorText = ''
      let temp = this.sku.dimension.height
      this.sku.dimension.height = 0
      this.sku.dimension.height = temp
    },
    hurryShow () {
      this.$refs.skuModal.show()
    },
    show (sku, product) {
      this.refIdFeedback = ''
      this.prev = ''
      this.sku = {...sku}
      this.product = product
      this.specifications.splice(0, this.specifications.length)
      this.mute = true
      if (this.sku.id) {
        this.oldRefId = sku.refId
        this.title = 'Editar variante para el producto: ' + this.product.name
      } else {
        this.title = 'Crear variante para el producto: ' + this.product.name
      }

      this.errorText = ''
      this.successText = ''
      this.loading = true
      this.getSKUAttributes(this.product.category.id).then(
        (specifications) => {
          this.loading = false
          this.specifications = specifications.body
        },
        (error) => {
          console.log(error)
          this.loading = false
          this.errorText = 'Error obteniendo las especificaciones de la variante'
        }
      )
      this.getSkuHistory(this.sku.id).then(
        (response) => {
          this.history = response.body || []
        },
        (error) => {
          console.log(error)
          this.errorText = 'Error obteniendo el historial de la variante'
        }
      )
      this.$refs.skuModal.show()
    },
    handleInvalidFeedback () {
      if (!this.sku.refId || this.sku.refId === '') this.refIdFeedback = 'El refId es obligatorio'
      else if (!this.isValidInt32Integer(this.sku.refId, true, false)) this.refIdFeedback = 'refId inválido'
      else {
        this.refIdValidation = false
        if (this.isValidInt32Integer(this.sku.refId, true, false)) {
          this.verifyInProgress = true
          clearTimeout(this.timeout)
          this.timeout = setTimeout(() => {
            if (this.sku.id && this.oldRefId === this.sku.refId) {
              this.refIdFeedback = ''
              this.verifyInProgress = false
            } else {
              this.existRefId(this.sku.refId).then(res => {
                this.refIdValidation = !res.body
                this.verifyInProgress = false
                if (!this.refIdValidation) {
                  this.refIdFeedback = 'el refId ingresado se encuentra en uso'
                } else this.refIdFeedback = ''
              })
            }
          }, 2000)
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/catalog/SkuModal.vue